import React, { useState, useRef } from 'react';
import Header from '../../../components/Header';
import PlantRegPermitTable from './PlantRegPemitTable';
import { Plus } from 'lucide-react';
import ComponentHeader from '../../../components/ComponentHeader';
import CreatePlantPermitModal from '../../../components/CreatePlantSafetyPermit';
import { useSelector } from 'react-redux';

const PlantSafetyRegulation = () => {
  const [openModal, setOpenModal] = useState(false);
  const [editId, setEditId] = useState<number | null>(null);
  const tableRef = useRef<any>(null);

  const handleEdit = (id: number) => {
    setEditId(id);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditId(null);
  };

  const handleRefreshTable = () => {
    if (tableRef.current?.fetchWorkPermits) {
      tableRef.current.fetchWorkPermits();
    }
  };

  const handleSearch = (query: string) => {
    if (tableRef.current?.fetchWorkPermits) {
      tableRef.current.fetchWorkPermits(1, query);
    }
  };

  const role = useSelector((state: any) => state.user?.role);
  const isResponsiblePersonLV = role === 'responsible_person_lv';

  return (
    <div className="flex-1 flex flex-col overflow-hidden relative">
      <Header title={'Plant Safety Regulation - Work Permit'} />

      <div className="flex-1 overflow-auto">
        <div className="flex justify-between items-center mb-4">
          {/* Left Side */}
          {role === 'responsible_person_lv' && (
            <button
              className="flex items-center gap-2 bg-[#e84545] text-white ml-6 px-4 py-2 rounded-md text-sm font-medium hover:opacity-90 mt-6"
              onClick={() => setOpenModal(true)}
            >
              <Plus size={16} /> New Plant Safety Permit
            </button>
          )}
          {/* Right Side */}
          <div className="flex items-center gap-2 ml-auto">
            <ComponentHeader onSearch={handleSearch} />
          </div>
        </div>

        <PlantRegPermitTable ref={tableRef} onEdit={handleEdit} />
      </div>

      <CreatePlantPermitModal isOpen={openModal} onClose={handleCloseModal} editId={editId} onSuccess={handleRefreshTable} />
    </div>
  );
};

export default PlantSafetyRegulation;
